import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export interface ChequesTerceroResumenBarProps {
  resumen: {
    totalCount: number;
    totalImporte: number;
    enCarteraCount: number;
    vencenEsteMesCount: number;
  } | null;
  loading: boolean;
  formatCurrency: (n: number) => string;
}

const ChequesTerceroResumenBar: React.FC<ChequesTerceroResumenBarProps> = ({
  resumen,
  loading,
  formatCurrency,
}) => {
  if (loading && !resumen) {
    return (
      <Box sx={{ mb: 2, py: 1.5, px: 2, bgcolor: '#f5f8fc', borderRadius: 2, border: '1px solid #e3eaf3' }}>
        <Typography variant="body2" color="text.secondary">
          Calculando resumen…
        </Typography>
      </Box>
    );
  }

  if (!resumen || resumen.totalCount === 0) return null;

  return (
    <Box
      sx={{
        mb: 2,
        py: 1.5,
        px: 2,
        bgcolor: '#f5f8fc',
        borderRadius: 2,
        border: '1px solid #e3eaf3',
      }}
      role="status"
      aria-live="polite"
    >
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 0.5, sm: 2 }} flexWrap="wrap" useFlexGap>
        <Typography variant="body2">
          <strong>{resumen.totalCount}</strong> cheques
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ·
        </Typography>
        <Typography variant="body2">
          Total <strong>{formatCurrency(resumen.totalImporte)}</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ·
        </Typography>
        <Typography variant="body2">
          En cartera: <strong>{resumen.enCarteraCount}</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ·
        </Typography>
        <Typography variant="body2">
          Vencen este mes: <strong>{resumen.vencenEsteMesCount}</strong>
        </Typography>
      </Stack>
    </Box>
  );
};

export default ChequesTerceroResumenBar;
